<template>
  <!-- //ROUTER IF DESKTOP -->
  <b-overlay
    id="overlay-export"
    :show="show"
    rounded="sm"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
  >    
    <section class="d-flex wrapper" >
      <div class="block block__challenges">
          <transition  
            name="fade"
            mode="in-out"
          >
            <router-view></router-view>
          </transition>
      </div>
    </section> 
  </b-overlay>
  <!-- //ROUTER IF DESKTOP -->
</template>

<script>
import { mapGetters } from 'vuex'
import CatMixin from './CatMixin'
// import utils from '../../Utils'


export default {
  name:"exports",
    components:{
    }, 
    mixins: [
      CatMixin 
    ],       
  data () {
    return {
        isMobile:false,
        show: false
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  created(){
    window.addEventListener('wheel', this.handleScroll);
  },
  activated() {
    window.addEventListener('wheel', this.handleScroll);
  },
  deactivated() {
    window.removeEventListener('wheel', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('wheel', this.handleScroll);
  },
  methods:{
    showLoader:function (e){
      this.show = !e ? true : false;
    },
    handleScroll () {
      var container = this.$el.querySelector(".block__challenges");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".sidebarChallenges");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".block__challengesAccueil");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".column-middle");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".column-right");
      if (container){
        container.scrollTop += event.deltaY;
      }
    }
  }
};
</script>
